export const serverConfig = {
    TARGET_TICKS_PER_SECOND: 20,
    TARGET_DELTA_IN_SECONDS: 1 / 20,
    TARGET_DELTA_IN_MS: 1000 / 20
};
